import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCabinet = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M21.816 5.566H2.182v13.09h19.634zM2.182 3.384A2.18 2.18 0 0 0 0 5.566v13.09c0 1.204.977 2.181 2.182 2.181h1.094v1.091a1.09 1.09 0 0 0 2.182 0v-1.09h13.089v1.09a1.09 1.09 0 1 0 2.181 0v-1.09h1.088a2.18 2.18 0 0 0 2.182-2.183V5.566a2.18 2.18 0 0 0-2.182-2.18z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCabinet);
export default Memo;
